export const BASE_URL = 'https://nasrme.ac.ir/backend'
export const MEDIA_URL = 'https://nasrme.ac.ir'
// export const BASE_URL = 'http://127.0.0.1:8000/backend'
// export const MEDIA_URL = 'http://127.0.0.1:8000'
export const BASE_NAME = ''
export const TIMEOUT = 120000